import LocaleSwitcher from "../../i18n/LocaleSwitcher"
export default function Header(){
    return(
        <header className="py-4 flex justify-end">
            <LocaleSwitcher />
        </header>
    )
}